import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=9d87d862&scoped=true&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"
import style0 from "./favorite.vue?vue&type=style&index=0&id=9d87d862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d87d862",
  null
  
)

export default component.exports